import React, { useState, useEffect, useRef } from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Dropdown } from 'primereact/dropdown';
import "./IncentiveActivityDetails.scss";
import "../../Dashboard.scss";
import NoRecordFound from "../../../../Shared/Component/NoRecordFound/NoRecordFound";
import { useDispatch, useSelector } from 'react-redux';
import { fetchIncentiveDetails } from '../../../../Store/Dashboard/AshaAnmSection/AshaAnmSectionActions';
import { useLanguage } from '../../../ChangeLanguage/LanguageProvider';
import { getIncentiveData } from '../../../../Store/Dashboard/AshaAnmSection/AshaAnmSectionSelectors';
import { useTranslation } from 'react-i18next';
const IncentiveActivityDetails = ({ ashaId}) => {
    const {selectedLanguageId}=useLanguage();
    const incentiveData = useSelector(getIncentiveData)
    const months = [
        'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'
      ];
    const years = [ 2022, 2023, 2024, 2025,2026];
    const currentYr = new Date().getFullYear();
    const currentMonth = months[new Date().getMonth()];
    const [data, setData] = useState([]);
    const [selectedMonth, setSelectedMonth] = useState(currentMonth);
    const [selectedYear, setSelectedYear] = useState(currentYr);
    const dispatch = useDispatch();
    const { t } = useTranslation('Incentive');
    const hasFetchedInitially = useRef(false);
    useEffect(() => {
        if (!hasFetchedInitially.current) {
            hasFetchedInitially.current = true;  // Prevents duplicate initial call
        }
        dispatch(fetchIncentiveDetails(ashaId, selectedLanguageId, selectedMonth, selectedYear));
    }, [dispatch,ashaId, selectedLanguageId, selectedMonth, selectedYear]);
    useEffect(() => {
        setData(incentiveData);
    }, [incentiveData]);
    const handleMonthChange =(value)=>{
        setSelectedMonth(value)
        dispatch(fetchIncentiveDetails(ashaId,selectedLanguageId,value,selectedYear));
    }

    const handleYearChange=(value)=>{
        setSelectedYear(value)
        dispatch(fetchIncentiveDetails(ashaId,selectedLanguageId,selectedMonth,value));
    }

    const activityBodyTemplate = (props) => {
        return (
            <div className={`${props.activityName === 'Total' ? "font-medium":
                "font-normal text-left"}`} style={{color:"#2C3D8F",marginLeft:"0.5rem"}}>
                {props.activityName}
            </div>
        );
    }

    const activityCountTemplate = (props) => {
        return (
            <div class="text-left" style={{marginLeft:"0.5rem",color:"#333333"}}>
                {props.totalActivityCount}
            </div>
        );
    };


    const actualIncentiveCount = (props) => {
        return (
            // <div class="text-left" style={{marginLeft:"0.5rem", color:"#333333"}}>
            <div class="text-left" style={{marginLeft:"0.5rem", color:"#333333"}}>
                  {props.actualIncentive}
            </div>
        );
    };
    const paidIncentiveCount = (props) => {
        return (
            // <div class="text-left" style={{marginLeft:"0.5rem", color:"#333333"}}>
            <div class="text-left" style={{marginLeft:"0.5rem", color:"#333333"}}>
                  {props.paidIncentive}
            </div>
        );
    }

    const pendingIncentiveCount = (props) => {
        return (
            // <div class="text-left" style={{marginLeft:"0.5rem", color:"#333333"}}>
            <div class="text-left" style={{marginLeft:"0.5rem", color:"#333333"}}>
                  {props.remainingIncentive}
            </div>
        );
    }

    const rowClass = (data) => {
        return {
            'bold-total-row': data.activityName === 'Total'
        };
    };

    return (
        <div className="tableScreen">
            <div>
                <div class="flex align-items-center mb-3">
                    <div class="text-sm font-semibold text-blue-900 mr-2">
                    {t('ActivityIncentivefor')}
                    </div>
                    <Dropdown
                        id="month"
                        data-testid='month'
                        value={selectedMonth}
                        options={months}
                        onChange={(e) => handleMonthChange(e.value)}
                        className="cockpit-dropdown mr-2"
                    />
                    <Dropdown
                        id="year"
                        value={selectedYear}
                        options={years}
                        onChange={(e) => handleYearChange(e.value)}
                        className="cockpit-dropdown"
                    />
                </div>
                <div className="card" >
                    {data&& data.length > 0 ? <>
                        <div  class="border-round">
                            <DataTable value={data} resizableColumns size="small" rowGroupMode="rowspan" groupRowsBy="remarks"
                                scrollable
                                scrollHeight="510px"
                                rowClassName={rowClass}
                                >
                                <Column field="activityName" header={t('ActivityName')} body={activityBodyTemplate}/>
                                <Column field="totalActivityCount" header={t('ActivityCount')} body={activityCountTemplate}/>
                                <Column field="actualIncentive" header={t('AppliedIncentives')} body={actualIncentiveCount}/>
                                {/* <Column field="paidIncentive" header={t('PaidIncentives')} body={paidIncentiveCount}/> */}
                                {/* <Column field="remainingIncentive" header={t('RemainingInventives')} body={pendingIncentiveCount}/> */}
                                {/* <Column field="remarks" header={t('Remarks')} ></Column> */}
                            </DataTable>
                        </div>
                        <p> {data && data.length-1} {t('TotalRecords')}  </p>
                    </>
                    :<NoRecordFound/>
}
                </div>
            </div>
        </div>
    );
}
export default IncentiveActivityDetails;
